<style lang="scss" scoped>
@import "$vars";

.star-block {
  margin: 30px auto 60px;
  text-align: center;
  .star-text {
    color: #4a4a4a;
  }
  .star-list {
    list-style: none;
    .star-item {
      margin: 0 7px;
      display: inline-block;
      cursor: pointer;
    //   &:hover {
    //     .form-star {
    //       background-color: #f8c93a;
    //     }
    //     &:first-of-type {
    //       .form-star {
    //         background-color: #f8c93a;
    //       }
    //     }
    //   }
      .form-star {
        width: 50px;
        &.colored {
          background-color: #f8c93a;
        }
      }
    }
  }
  .btn-send {
    margin-top: 40px;
  }
  .display-message {
    margin-top: 40px;
  }
}

h3 {
  color: #4a4a4a;
  font-family: $base-font-family;
  font-size: 24px;
  font-weight: 600;
}

h4 {
  color: #4a4a4a;
  font-family: $base-font-family;
  font-size: 18px;
  font-weight: 600;
}

.align-center {
  align-items: center;
  justify-content: center;
}

.mgn-top-0 {
  margin-top: 0 !important;
}

.mg-left {
  margin-right: 20px;
}
</style>

<template>
  <main class="component-patients" v-if="loaded">
    <h3 class="text-center">Consulta encerrada com sucesso!</h3>
    <div class="star-block">
      <h4 class="star-text">Que nota você dá para o(a) paciente de 1 a {{ totalStars }}?</h4>
      <ul class="star-list">
        <li v-for="star in totalStars" class="star-item" :key="star">
          <span @click="selectStar(star)">
            <dr-icon
              class="form-star"
              :fill="star <= selectedStar ? 'yellow' : 'gray'"
              :name="star <= selectedStar ? 'starFull' : 'star'"
            ></dr-icon>
          </span>
        </li>
      </ul>

      <div class="d-flex flex-middle align-center">
        <button class="btn btn-green mg-left" @click="$router.push({ name: 'DoctorAppointmentsList' })">Cancelar</button>
        <dr-submit class="btn-send mgn-top-0" text="Avaliar" :disabled="sent" :sending="sending" @click="submit()"></dr-submit>
      </div>

      <p class="display-message">Essa avaliação é confidencial e apenas será usada como estatística e avaliação interna.</p>
    </div>
  </main>
</template>

<script>
import drSubmit from '@/components/form/submit.vue'
export default {
  props: ['agenda_id', 'isMedicalHistoryVisible'],
  components: {drSubmit},
  data () {
    return {
      loaded: false,
      totalStars: 5,
      selectedStar: 0,
      sending: false,
      sent: false
    }
  },
  created () {
    this.loaded = true
  },
  methods: {
    selectStar (value) {
      if (!this.sent) {
        this.selectedStar = value
      }
    },
    submit () {
      this.sending = true
      let data = {
        grade: this.selectedStar
      }

      if (data.grade > 0) {
        this.$http.post(`/agenda/${this.agenda_id}/patient_grade`, {'patient_grade': data}, this.$store.getters.getAuthHeader).then(
          (res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Avaliação enviada com sucesso',
              size: 'md',
              active: true
            })
            this.sent = true
            this.sending = false
            this.fn_HIDE_PROGRESS()
            this.$router.push({name: 'DoctorAppointmentsList'})
          }
        ).catch(
          (err) => {
            console.log(err)
            this.$store.dispatch('setModalAlert', {
              title: 'Erro',
              body: 'Ocorreu um erro, tente novamente mais tarde',
              size: 'md',
              active: true
            })
          }
        ).finally(() => {
          this.sending = false
          this.fn_HIDE_PROGRESS()
        })
      } else {
        this.sending = false
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Por favor, escolha uma nota de avaliação para o paciente.',
          size: 'md',
          active: true
        })
      }
    }
  }
}
</script>
